import { StateInterface } from 'client/Interfaces/StateInterface'
import {
  ConsumablesBillingStatus,
  ConsumablesType,
  QuotaTypes,
  SubscriptionInterface,
  TinkFreeConsumablesLimit,
} from 'client/Interfaces/Subscription'
import { doesCurrentPlanSupportFeature } from 'client/reducers/Subscription/companySubscription'

const IBAN = require('iban')

export const isIBANValid = (iban) => {
  return iban.length ? !!IBAN.isValid(iban) : true
}

export const hasUsedFreeTinkUnpaidPlan = (state: StateInterface) => {
  const { subscription, subscriptionManagement } = state
  const extraFreebies = subscriptionManagement?.settings?.settings?.extraObpFreebies || 0
  const hasPremiumAccess = doesCurrentPlanSupportFeature(subscription, QuotaTypes.ONLINE_BANK_PAYMENTS)
  const freeTinkConsumablesUsed = subscription?.consumables[ConsumablesType.TINK_PAYMENT][ConsumablesBillingStatus.FREE]
  return !hasPremiumAccess && freeTinkConsumablesUsed >= TinkFreeConsumablesLimit.MAX_FREE + extraFreebies
}
